// Module
var code = `<blip-copilot-mfe class="flex-auto" language="{{\$ctrl.language}}" ownerIdentity="{{\$ctrl.ownerIdentity}}" settings="{{\$ctrl.settingsSource}}" permission="{{\$ctrl.canEditDesk}}" wsparams="{{\$ctrl.webSocketParams}}" width="{{\$ctrl.width}}" user="{{\$ctrl.user}}"></blip-copilot-mfe>`;
// Exports
module.exports = code;